import { forwardRef } from "react";

import { Button, Icon_TriangleDown } from "@shapr3d/frontend-lib";
import type { ButtonHTMLAttributes } from "react";
import { useParams } from "react-router-dom";

import { ReactComponent as Icon_Briefcase } from "../../assets/images/briefcase.svg";
import { useTeam } from "../../hooks/useTeams";

import style from "./TeamSelectorActivator.module.css";

export const TeamSelectorActivator = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(({ ...attrs }, ref) => {
  const { teamID } = useParams();
  const currentTeam = useTeam(teamID);

  return (
    <Button {...attrs} ref={ref} className={style.teamSelectorActivator} variant="grayscale">
      <div className={style.content}>
        <span className={style.avatar}>
          <Icon_Briefcase />
        </span>
        <span className={style.name}>{currentTeam?.name}</span>
        <Icon_TriangleDown />
      </div>
    </Button>
  );
});
